import styled from 'styled-components';

import { IconButton } from '../../IconButton/IconButton';

export const ClearIconButton = styled(IconButton)`
    && {
        height: 20px;
        width: 20px;
    }
`;
